import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface setSyncTrType {
  params: { id_transactions: string };
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
}

export default ({ errorCallback, resultKey = 'syncTr', params, successCallback }: setSyncTrType) =>
  requestAsync({
    url: endpoints.setSyncTrUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.setSyncTrUrl(params),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
